import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { DatePipe, Location } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Page } from 'src/app/models/page.model';
import { IonSelect, IonContent } from '@ionic/angular';


import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';

import { MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import * as moment from "moment"
import * as uuid from 'uuid';
// import { NullTemplateVisitor } from '@angular/compiler';


export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY HH:mm',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};


@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
  ],
})
export class UserPage implements OnInit {

  @ViewChild('domainRolesTable', { static: false }) domainRolesTable: DatatableComponent;
  @ViewChild('passwordForm', { static: false }) passwordForm: any;
  @ViewChild('confirmResetCountPasswordForm', { static: false }) confirmResetCountPasswordForm: any;

  @ViewChild('focusconfirmPassword', { static: false }) focusconfirmPassword;
  @ViewChild('focusresetCount', { static: false }) focusresetCount;

  @ViewChild('userroleSelect', { static: false }) userroleSelect: IonSelect;
  @ViewChild('content', { static: false }) private content: IonContent;

  @ViewChild('matSelect', { static: false }) matSelect: any;
  @ViewChild('searchFocus', { static: false }) ionInput: { setFocus: () => void; };

  page = new Page();
  userForm: FormGroup;
  submitted = false;
  userId: string;
  user: any = {};
  showPage: boolean = false;
  preventClick: boolean = true;
  deleteUser: boolean = false;
  searchText :any = ''
  tempUserRole: any = []
  showSearchContainer: boolean = false;
  AccessAllDomain: number = 0
  showObjectGroups: boolean = false;
  toggleSubscription: Subscription;
  itemsSelected: any = [];
  domainItemsSelected: any = [];
  rows = [];
  showRetryCount = true;
  showDomainRoles: boolean = false;
  domainRolesChanged: boolean = false;
  isDomainSelectDisabled: boolean = false;
  refresh: boolean = true;
  selectedDomainIds = [];
  showMasterOnly: boolean = false
  isAlreadycase: boolean = false
  disableRoleSelection: boolean = false
  isNewAdd: boolean = false
  filterMaster: any = {}
  isAddDisable: boolean = false
  tempDomains: any = []

  tempPaginatorRoles: any = []



  forceCurrentPage: any = null

  showConfirmPassword: boolean = false;
  showConfirmResetCountPassword: boolean = false;
  showEnableActivityExpiryEmail: boolean = true;
  showApproveEmail: boolean = true;

  locale: any;
  tempLocale: any;

  birthDate: any;
  category: string = ''

  showCompany: boolean = false
  selectedDomainName: any = ''


  globalRole: any = null

  DomainRoleTaker: any = [];
  userRoleTaker: any = [];
  show2FA: boolean = false
  allLocales: any = [];
  // public getoptions: Options;
  saveUserFlag: boolean = false;

  pageSize: number = 5;
  skip: number = 0;
  count: number = 0;
  paginatorRoles: any = []
  tempDomainROles: any = []
  isAdmin:boolean = false;
  showLinkedToAllDomain: boolean = false

  forcePageNumber: any = null
  disableDelete: boolean = false
  showDelete: boolean = true

  domainList: any = {};
  companies: any = []
  public max = new Date(moment().format());

  controlStatus: any = {
    Password: false,
    EmailAddress: false,
    PhoneNumber: false,
    MobileNumber: false,
    ConfirmPassword :false,
    TeamLeaderGuid: false
  };
  isSSO: boolean = false;
  paramDomainId: string = '';

  constructor(private router: Router, private el: ElementRef, private route: ActivatedRoute, private cd: ChangeDetectorRef, private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private datePipe: DatePipe, public ngxSmartModalService: NgxSmartModalService, private location: Location, private dateTimeAdapter: DateTimeAdapter<any>) {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.category = 'domainRoles'
    this.skip = 0;
    this.pageSize = 5;
    if(this.route.queryParams) {
      this.route.queryParams.subscribe(param=> {
        this.paramDomainId = param['domainId'] ? param['domainId'] : '';
      })
    }
  }

  columnsWidth: any = [];

  ngOnInit() {
    this.getLocales();
    this.getRoles();
    this.userForm = this.formBuilder.group({
      Status: [true],
      RoleId: ['', Validators.required],
     // DomainId: [''],
      FirstName: ['', Validators.required],
      Infix: [''],
      CompanyId: ['', Validators.required],
      LastName: ['', Validators.required],
      Initials: [''],
      // Company: [''],
      PhoneNumber: ['', [Validators.pattern(this._commonService.phonePattern)]],
      TeamLeaderGuid: ['', [Validators.pattern(this._commonService.guidPattern)]],
      Gender: [''],
      Birthdate: [''],
      MobileNumber: ['', [Validators.pattern(this._commonService.phonePattern)]],
      EmailAddress: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required, Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]],
      ConfirmPassword: ['', [Validators.required, Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]],
      Function: [''],
      EnableApprovalEmail: [''],
      Enable2FactorAuthentication: [true],
      EnableActivityExpiryEmail: [false],
      ExpiryEmailDays: [''],
      DefaultLocale: [this._commonService.locale ? this._commonService.locale : 1043, Validators.required],
      Department: [''],
      LastLoggedIn: [''],
      DateCreated: [''],
      LastModified: [''],
      Description: [''],
      Newspaper:[false]
    },
      {
        validator: this.MatchPassword ,// Inject the provider method
      }
    );
  }

  ionViewWillEnter(){
    this.showSearchContainer = false;
    if(localStorage.isSSO && localStorage.isSSO == 'true' ) {
      this.isSSO = true;
    }
  }

  ionViewDidEnter() {
    this.user.DomainRoles = [];
    this.paginatorRoles = [];
    this.showMasterOnly = false;
    this.isAlreadycase = false
    this.forceCurrentPage = null;
    this.forcePageNumber = null
    this.isDomainSelectDisabled = false
    this.disableDelete = false
    this.disableRoleSelection = false
    this.searchText = ''
    this.skip = 0
    this.globalRole = null
    if(localStorage.Force2FactorAuthentication == 'True'){
      this.show2FA = true
    }

    if(localStorage.roleCode == 'UserRole_CustomerAdmin'){
      this.showCompany = true
    }else{
      if(localStorage.roleCode == 'UserRole_Administrator'){
        this.isAdmin = true;
      }
    }



    if( localStorage.isCustomerAdminDeleteDisable && (JSON.parse(localStorage.isCustomerAdminDeleteDisable) == true)){
      this.showDelete = false
    }

    this.showLinkedToAllDomain = false
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if (this.locale == '1043') {
      this.dateTimeAdapter.setLocale('nl');
    } else {
      this.dateTimeAdapter.setLocale('en');
    }
    this.showPage = false;
    this.showApproveEmail = false;
    this.deleteUser = false;
    this.showRetryCount = false;
    this.userId = this.route.snapshot.paramMap.get('id');
    if (this.userId == '0') {
      this.userId = null;
      this.user.Birthdate = "";
    }

    if (this.userId) {
      this.getUserDetails();
    } else {
      this.getInfos();
    }
    this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
      setTimeout(() => {
        if (this.domainRolesTable && (this._commonService.domain.Name.toLowerCase() == 'master')) {
          this.user.DomainRoles = [...this.user.DomainRoles];
          this.domainRolesTable.recalculate();
        }
      }, 0)
    });
  }


  onLocaleChanged() {
    this.locale = event
    if (this.locale == '1043') {
      this.dateTimeAdapter.setLocale('nl');
    } else {
      this.dateTimeAdapter.setLocale('en');
    }
  }



  adjustColumnWidth() {
    if (this.domainRolesTable && window.innerWidth > 800) {
      let tableWidth = this.domainRolesTable._innerWidth - 30;
      this.columnsWidth.Domain = (50 / 100) * tableWidth;
      this.columnsWidth.Role = (50 / 100) * tableWidth;

    }
    if (this.domainRolesTable && window.innerWidth < 800) {
      let tableWidth = this.domainRolesTable._innerWidth - 30;
      this.columnsWidth.Domain = (50 / 100) * tableWidth;
      this.columnsWidth.Role =  (50 / 100) * tableWidth;


    }
  }


  async getInfos() {
    this.showPage = true;
    this.isNewAdd = true
    this.getRoles();
    if (this._commonService.domain.Name.toLowerCase() == 'master') {
      await this.getDomains();
    }
    if (this.showCompany) {
      await this.getCompanies();
    }

    this.user.DomainRoles = [];
    this.paginatorRoles = []
    this.count = 0
    this.setUserRoleValidation();
    this.setCompanyRoleValidation()

    let segmentButtons = document.querySelectorAll('ion-segment-button');
    segmentButtons.forEach((button) => {
      button.shadowRoot.querySelector('.button-native').setAttribute('style', 'margin:0px;padding: 3px 13px;font-weight: 400;justify-content: flex-start;')
    })
    setTimeout(() => {
      this.adjustColumnWidth();
    }, 0)

    if(this.paramDomainId) {
      this.isAddDisable = true;
      let defaultDomain = this.user.Domains.find(x => x.DomainId == this.paramDomainId);
      let defaultRole = this.user.AllRoles.find(x => x.UserRoleCode == "UserRole_CustomerAdmin");
      let obj = {
        DomainId: this.paramDomainId,
        DomainName: defaultDomain.Name,
        RoleId: defaultRole.UserRoleId,
        isDomainSelectDisabled: true
      }
      this.user.DomainRoles.push(obj);
      if(this.user.DomainRoles &&  this.user.DomainRoles.length > 0){
        this.user.Domains = [...this.user.Domains.filter(f => f.Name.toLowerCase() != 'master')]
        this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')];
        this.count  = this.user.DomainRoles.length  ? this.user.DomainRoles.length : 0;
        //this.skip = 0;
        this.paginatorRoles = this.user.DomainRoles.slice(this.skip, this.pageSize);
      }
    }
  }

  async getDomains() {
    try {
      //Change for : RECH3-167
      // if (localStorage.domainList) {
      //   this.user.Domains = JSON.parse(localStorage.domainList);
      //   this.tempDomains = JSON.parse(localStorage.domainList);
      // } else {
      let domainData = await this._apiService.getDomains('', '', '', 1, 0, true);
      this.user.Domains = domainData.body;
      this.tempDomains =  domainData.body;
      localStorage.domainList = this.user.Domains;
      localStorage.setItem('domainList', this.user.Domains ? JSON.stringify(this.user.Domains) : null);
      // }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  setUserRoleValidation() {
    const userRoleControl= this.userForm.get('RoleId');
    if (this.showPage) {
      if (this._commonService.domain.Name.toLowerCase() != 'master') {
        userRoleControl.setValidators([Validators.required]);
        userRoleControl.updateValueAndValidity();
      }else{
        userRoleControl.setValidators(null);
        userRoleControl.updateValueAndValidity();
      }
    }

  }

  setCompanyRoleValidation(){
    const companyControl= this.userForm.get('CompanyId');
    if (this.showPage) {
      if (this._commonService.domain.Name.toLowerCase() != 'master') {
        companyControl.setValidators([Validators.required]);
        companyControl.updateValueAndValidity();
      }else{
        companyControl.setValidators(null);
        companyControl.updateValueAndValidity();
      }
    }
  }

  async getCompanies() {
    try {
        let companyData = await this._apiService.getCompanies('', '', '', 1, 0);
        this.companies = companyData.body;
    } catch (error) {
      this._commonService.dismiss()
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getRoles() {
    try {
      if (localStorage.userRoles) {
        this.user.AllRoles = JSON.parse(localStorage.userRoles);
        this.tempUserRole = JSON.parse(localStorage.userRoles)

      } else {
        let roleData = await this._apiService.getUserRoles('', 1, 0);
        this.user.AllRoles = roleData.body;
        this.tempUserRole =  roleData.body
        localStorage.setItem('userRoles', JSON.stringify(roleData.body));
      }

      if (localStorage.roleCode == 'UserRole_CustomerAdmin' && this.isNewAdd) {
        this.disableRoleSelection = true

        this.userForm.patchValue({
          RoleId: this.user.AllRoles.find(f => f.UserRoleCode == 'UserRole_CustomerUser').UserRoleId
        })
        this.user.AllRoles = [...this.user.AllRoles.filter(role => role.UserRoleCode == 'UserRole_CustomerUser')];
      }else if (localStorage.roleCode == 'UserRole_CustomerAdmin' && !this.isNewAdd){
        this.user.AllRoles = [...this.user.AllRoles.filter(role => role.UserRoleCode == 'UserRole_CustomerUser' || role.UserRoleCode == 'UserRole_CustomerAdmin' )];
        this.disableRoleSelection = true
      }else{
        this.disableRoleSelection = true
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        let icon;
        this.allLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.allLocales.length; i++) {
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }

      } else {
        let icon;
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.allLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
        for (let i = 0; i < this.allLocales.length; i++) {
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.allLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.allLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.allLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async getUserDetails() {
    try {
      this._commonService.presentLoading();
      this.refresh = false;
      let res = await this._apiService.getUser(this.userId);
      this.user = res.body;


      await this.getRoles();


      if (this._commonService.domain.Name.toLowerCase() == 'master') {
        await this.getDomains();

        if(this.user.DomainRoles &&  this.user.DomainRoles.length > 0){
          this.user.DomainRoles.forEach(element => {
            let roleCode = this.user.AllRoles.find(f=> f.UserRoleId == element.RoleId).UserRoleCode
            if(element.DomainName.toLowerCase() == 'master'){
              if(roleCode == 'UserRole_Administrator'){
                this.showMasterOnly = true
              }
              if (roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal'){
                element.disableDelete = true
                element.isDomainSelectDisabled = true
                let index = this.user.DomainRoles.findIndex((item, index) => { return item.DomainId == element.DomainId });
                if(index > 0){
                    this.array_move(this.user.DomainRoles,index, 0)

                }else if(index == 0){

                  this.isAlreadycase = true
                }

              }

            }else{
               if (roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal'){
                this.globalRole = roleCode
              }
            }
            if(roleCode == 'UserRole_CustomerAdmin' || roleCode == 'UserRole_CustomerUser'){
              this.user.Domains = [...this.user.Domains.filter(f => f.Name.toLowerCase() != 'master')]
            }
          });

          if( this.user.DomainRoles && this.user.DomainRoles.length > 0){

            let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
            if(firstElem && firstElem.DomainId){
              this.isAddDisable = false
              let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
              if(domainName == 'master'){
                this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
              }else{
                this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
              }
            }
          }

        }

        this.checkToShowAllLinkedDomain()
      }

      if(this.user.DomainRoles){
        this.count  = this.user.DomainRoles.length  ? this.user.DomainRoles.length : 0
        if(this.count > 0){
            this.paginatorRoles = this.user.DomainRoles.slice(this.skip, this.pageSize)
        }else{
          this.paginatorRoles = []
        }
      }

      if (this.showCompany) {
        await this.getCompanies();
      }

      this._commonService.log(this.user, this._commonService.LOG);

      if (this._commonService.domain.Name.toLowerCase() != 'master') {
        let role = this.user.AllRoles.find(el => el.UserRoleId == this.user.RoleId);
        if (role) {
          this.user.UserRole = role.UserRoleId;
          this.userForm.patchValue({
            RoleId: role,
          });
        }
      }

      if (!this.user.RetryCount) {
        this.user.RetryCount = 0;
      }

      if (this.user.RoleId && (this.user.RoleId == "0a1061fa-5015-4f37-85e0-66ae19e9b178" || this.user.RoleId == "fe0380d2-aea5-4c20-95a6-5882712eaf84" || this.user.RoleId == "a268d471-b525-42f2-a6e6-73ec4073f3fb")) {
        this.showEnableActivityExpiryEmail = true;
      } else {
        this.showEnableActivityExpiryEmail = false;
      }

      if (this.user.RoleId === 'fe0380d2-aea5-4c20-95a6-5882712eaf84' || this.user.RoleId === 'a268d471-b525-42f2-a6e6-73ec4073f3fb') {
        this.showApproveEmail = true;
      } else {
        this.showApproveEmail = false;
      }
      this.AccessAllDomain =  Number(this.user.AccessAllDomain) ? 1 : 0,
      this.userForm.patchValue({
        Status: Number(this.user.Status) ? true : false,
        EnableApprovalEmail: Number(this.user.EnableApprovalEmail) ? true : false,
        Enable2FactorAuthentication: Number(this.user.Enable2FactorAuthentication) ? true : false,
        EnableActivityExpiryEmail: Number(this.user.EnableActivityExpiryEmail) ? true : false,
        ExpiryEmailDays: this.user.ExpiryEmailDays,
        Initials: this.user.Initials,
        FirstName: this.user.FirstName,
        Infix: this.user.Infix,
        LastName: this.user.LastName,
        Gender: this.user.Gender,
        RoleId: this.user.RoleId? this.user.RoleId : "",
        PhoneNumber: this.user.PhoneNumber,
        CompanyId: this.user.CompanyId,
        MobileNumber: this.user.MobileNumber,
        EmailAddress: this.user.EmailAddress,
        Password: "********",
        ConfirmPassword: "********",
        Function: this.user.Function,
        LastLoggedIn: this.datePipe.transform(new Date(this.user.LastLoginDate), "dd-MM-yyyy HH:mm:ss"),
        LastModified: this.datePipe.transform(new Date(this.user.DateModified), "dd-MM-yyyy HH:mm:ss"),
        DateCreated: this.datePipe.transform(new Date(this.user.DateCreated), "dd-MM-yyyy HH:mm:ss"),
        Department: this.user.Department,
        DefaultLocale: this.user.DefaultLocale ? this.user.DefaultLocale : this._commonService.locale,
        Description: this.user.Description,
        Newspaper: Number(this.user.Newspaper) ? true : false
      });
      if(this.isAdmin){
        this.userForm.patchValue({
          TeamLeaderGuid : this.user.TeamLeaderGuid
        })
      }
      const passwordControl = this.userForm.get('Password');
      passwordControl.clearValidators();
      passwordControl.setErrors(null);

      if (localStorage.roleCode && ((localStorage.roleCode === 'UserRole_Administrator') || (localStorage.roleCode === 'UserRole_Moderator'))) {
        this.showRetryCount = true;
      }


      this._commonService.dismiss();
      this.userForm.updateValueAndValidity();
      this.showPage = true;
      this.refresh = true;
       this.setUserRoleValidation();
       this.setCompanyRoleValidation()
      setTimeout(() => {
        if (this.userroleSelect) this.userroleSelect.disabled = true;
        let segmentButtons = document.querySelectorAll('ion-segment-button');
        segmentButtons.forEach((button) => {
          button.shadowRoot.querySelector('.button-native').setAttribute('style', 'margin:0px;padding: 3px 13px;font-weight: 400;justify-content: flex-start;')
        })

        if (this.userroleSelect) this.userroleSelect.disabled = false;
      }, 0)

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.userForm.controls; }

  async saveUserDetails(form) {
    if (this.deleteUser) {
      try {
        if(!this.isSSO){
          this.ngxSmartModalService.getModal('confirmPassword').close()
        }
        this.showConfirmPassword = false;
        this._commonService.presentLoading();
        await this._apiService.deleteUserWithPasswordPrompt(this.userId, this.isSSO?'':form.value.UserPassword);
        this._commonService.dismiss();
        this.location.back();
      } catch (error) {
        this._commonService.log(error, this._commonService.ERROR);
        this._commonService.dismiss();
      }
    } else {
      if (this.userForm.invalid) {
        this._commonService.scrollToError();
        return;
      }
      if(!this.isSSO){
        this.ngxSmartModalService.getModal('confirmPassword').close()
      }
      this.showConfirmPassword = false;
      this._commonService.presentLoading();
      try {
        let data = {
          UserId: this.userId ? this.userId : null,
          Status: this.userForm.value.Status ? '1' : '0',
          EnableApprovalEmail: this.userForm.value.EnableApprovalEmail ? '1' : '0',
          Enable2FactorAuthentication: this.userForm.value.Enable2FactorAuthentication ? '1' : '0',
          EnableActivityExpiryEmail: this.userForm.value.EnableActivityExpiryEmail ? '1' : '0',
          ExpiryEmailDays: this.userForm.value.EnableActivityExpiryEmail ? this.userForm.value.ExpiryEmailDays : null,
          //RoleId: this.userForm.value.RoleId,
          //DomainId: localStorage.domainName.toLowerCase() == 'master' ? (this.userForm.value.RoleId == 'e7abb15c-651d-4bff-a91e-8cf369a0d080' || this.userForm.value.RoleId == '0a1061fa-5015-4f37-85e0-66ae19e9b178') ? localStorage.domainId : (this.userForm.value.RoleId == 'fe0380d2-aea5-4c20-95a6-5882712eaf84' || this.userForm.value.RoleId == 'a268d471-b525-42f2-a6e6-73ec4073f3fb') ? null : this.userForm.value.DomainId : localStorage.domainId,
          Initials: this.userForm.value.Initials,
          FirstName: this.userForm.value.FirstName,
          Gender: this.userForm.value.Gender,
          Infix: this.userForm.value.Infix,
          AccessAllDomain: this.AccessAllDomain ? '1' : '0',
          LastName: this.userForm.value.LastName,
          Birthdate: this.user.Birthdate? this.datePipe.transform(new Date(this.user.Birthdate), "yyyy-MM-dd"): null,
          PhoneNumber: this.userForm.value.PhoneNumber,
          TeamLeaderGuid: this.userForm.value.TeamLeaderGuid,
          MobileNumber: this.userForm.value.MobileNumber,
          CompanyId: this.userForm.value.CompanyId,
          EmailAddress: this.userForm.value.EmailAddress.trim(),
          Password: this.userForm.value.Password.replace(/\s+/g, ''),
          Function: this.userForm.value.Function,
          Department: this.userForm.value.Department,
          Description: this.userForm.value.Description,
          DefaultLocale: this.userForm.value.DefaultLocale,
          DomainRoles: this.user.DomainRoles,
          Newspaper:  this.userForm.value.Newspaper ? '1' : '0'
        }
        if(!this.isAdmin){
          delete data.TeamLeaderGuid;
        }
        if (!this.showEnableActivityExpiryEmail) {
          data.EnableActivityExpiryEmail = '0';
          data.ExpiryEmailDays = null;
        }

        if (this._commonService.domain.Name.toLowerCase() == 'master') {
          if(this.showMasterOnly){
            data.DomainRoles = [{
              DomainId: this.user.Domains.find(f => f.Name.toLowerCase() == 'master').DomainId,
              RoleId: this.user.AllRoles.find(f => f.UserRoleCode == 'UserRole_Administrator').UserRoleId
            }]

          }else{
            data.DomainRoles = this.user.DomainRoles.length > 0 ? this.user.DomainRoles.map( k => {
              return {
                DomainId: k.DomainId,
                RoleId: k.RoleId
              }
            }) : null
          }
        } else {
          data.DomainRoles = [
            {
              DomainId: localStorage.domainId,
              RoleId: this.userForm.value.RoleId
            }
          ]
        }
        let domainIds = [];
        let domains = [];
        if(data.DomainRoles){
          data.DomainRoles = data.DomainRoles.filter(k => k.RoleId != null);

          data.DomainRoles.forEach(element => {
            domainIds.push(element.DomainId)
          });

        }

        if (this.userId) {
          if (data.Password == "********" || data.Password == "" || this.isSSO) {
            delete data.Password
          }
          this._commonService.log(data, this._commonService.LOG);
          let res = await this._apiService.putUserWithPasswordPrompt(data, this.isSSO?'':form.value.UserPassword);
          if (res.id) {
            this.userId = res.id;
          }
          this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
          this._commonService.dismiss();
          this.domainRolesChanged = false;
          this.getUserDetails();
        }
        else {
          this._commonService.log(data, this._commonService.LOG);
          let res = await this._apiService.postUserWithPasswordPrompt(data, this.isSSO?'':form.value.UserPassword);
          if (res.id) {
            this.userId = res.id;
            this.location.replaceState('maintenance/users/' + this.userId);
          }
          this._commonService.dismiss();
          this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
          this.domainRolesChanged = false;
          this.getUserDetails();
        }
        this._commonService.log(data, this._commonService.LOG);
        this.saveUserFlag = false;

        this.submitted = false;
        this._commonService.dismiss();
      }
      catch (error) {
        this.saveUserFlag = false;
        this.submitted = false;


        this._commonService.log(error, this._commonService.ERROR);
        this._commonService.dismiss();
      }
    }
  }

  async onSubmit(userSaveFlag, addOGFlag, deleteOGFlag) {
    this.submitted = true;
    if (userSaveFlag) this.saveUserFlag = true;
    else this.saveUserFlag = false;

    if(this.user.Birthdate){
      this.userForm.patchValue({
            Birthdate: this.datePipe.transform(new Date(this.user.Birthdate), "dd-MM-yyyy"),
      })
    }

    if(this.isSSO){
      const password = this.userForm.get('Password');
      const confirmPassword = this.userForm.get('ConfirmPassword');
      password.setErrors(null);
      confirmPassword.setErrors(null);
    }

    if (this.userForm.invalid) {
      this.controlStatus.Password = true
      this.controlStatus.EmailAddress = true
      this.controlStatus.PhoneNumber = true
      this.controlStatus.TeamLeaderGuid = true
      this.controlStatus.MobileNumber = true
      let firstInvalidControl;
      firstInvalidControl = this.el.nativeElement.querySelector(
        "form .ng-invalid"
      );
      // if(!firstInvalidControl && this.userForm.controls.Birthdate.value == "") {
      //   firstInvalidControl = document.querySelector('input.ng-valid');
      // }
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });;
      return;
    }

    // if (this._commonService.domain.Name.toLowerCase() != 'master') {
    //   if (this.userForm.value.RoleId){
    //     this.userForm.controls['RoleId'].setErrors(null);
    //   }else{
    //     this.userForm.controls['RoleId'].setErrors({ 'incorrect': true });
    //   }
    // }

    if(this.user.DomainRoles && this.user.DomainRoles.length > 0 && this._commonService.domain.Name.toLowerCase() == 'master'){
      this.user.DomainRoles.forEach(element => {
        if(element.RoleId){
          let roleCode = this.user.AllRoles.find(f => f.UserRoleId == element.RoleId).UserRoleCode
          if(roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal'){
            let domainName = this.user.DomainRoles.find(f => f.DomainId == '100fdbfc-9894-415c-a79f-9de156c716de')
            if(!domainName){
                this._commonService.presentAlert('', 'Master is required')
            }else{
              if(!this.isSSO){
                this.showConfirmPassword = true;
                setTimeout(() => {
                  this.ngxSmartModalService.getModalStack().forEach(element => {
                    if (element.id === 'confirmPassword') {
                      this.ngxSmartModalService.getModal('confirmPassword').open();
                    }
                  });
                }, 0)
                setTimeout(() => {
                  this.focusconfirmPassword.setFocus();
                }, 200);
              }else{
                this.saveUserDetails(this.userForm)
              }

            }
          }else{
            if(!this.isSSO){
              this.showConfirmPassword = true;
              setTimeout(() => {
                this.ngxSmartModalService.getModalStack().forEach(element => {
                  if (element.id === 'confirmPassword') {
                    this.ngxSmartModalService.getModal('confirmPassword').open();
                  }
                });
              }, 0)
              setTimeout(() => {
                this.focusconfirmPassword.setFocus();
              }, 200);
            }else{
              this.saveUserDetails(this.userForm)
            }


          }
        }else{
          this._commonService.presentAlert('', 'Role must be selected')
        }
      });
    }else if(this.user.DomainRoles && this.user.DomainRoles.length == 0 && this._commonService.domain.Name.toLowerCase() == 'master') {
      this._commonService.presentAlert('', 'Domain and role must be selected')
    }else if(!(this._commonService.domain.Name.toLowerCase() == 'master')){
      if(!this.isSSO){
        this.showConfirmPassword = true;
        setTimeout(() => {
          this.ngxSmartModalService.getModalStack().forEach(element => {
            if (element.id === 'confirmPassword') {
              this.ngxSmartModalService.getModal('confirmPassword').open();
            }
          });
        }, 0)
        setTimeout(() => {
          this.focusconfirmPassword.setFocus();
        }, 200);
      }else{
        this.saveUserDetails(this.userForm)
      }
      }

  }

  cancelConfirmPasswordModal() {
    this.passwordForm.form.reset();
    this.passwordForm.submitted = false;
    setTimeout(() => {
      this.ngxSmartModalService.getModal('confirmPassword').close();
      this.showConfirmPassword = false;
    }, 5)
  }

  cancelResetRetryConfirmPasswordModal() {
    this.confirmResetCountPasswordForm.reset();
    this.confirmResetCountPasswordForm.submitted = false;
    this.ngxSmartModalService.getModal('confirmResetCountPassword').close();
    this.showConfirmResetCountPassword = false;
  }

  onReset() {
    this.submitted = false;
    this.userForm.reset();
  }

  onBlurMethod(controlName){

    if(controlName == 'Password'){
      this.controlStatus.Password = true
    }
    if(controlName == 'EmailAddress'){
     this.controlStatus.EmailAddress = true
   }
   if(controlName == 'PhoneNumber'){
    this.controlStatus.PhoneNumber = true
  }
  if(controlName == 'MobileNumber'){
    this.controlStatus.MobileNumber = true
  }
  if(controlName == 'ConfirmPassword'){
    this.controlStatus.ConfirmPassword = true
  }
  if(controlName == 'TeamLeaderGuid'){
    this.controlStatus.TeamLeaderGuid = true
  }

   }

   onFocusMethod(controlName){
     if(controlName == 'Password'){
       this.controlStatus.Password = false
     }
     if(controlName == 'EmailAddress'){
       this.controlStatus.EmailAddress = false
     }
     if(controlName == 'PhoneNumber'){
      this.controlStatus.PhoneNumber = false
    }
    if(controlName == 'MobileNumber'){
      this.controlStatus.MobileNumber = false
    }
    if(controlName == 'ConfirmPassword'){
      this.controlStatus.ConfirmPassword = false
    }
    if(controlName == 'TeamLeaderGuid'){
      this.controlStatus.TeamLeaderGuid = false
    }
   }

  ionViewDidLeave() {
    this.itemsSelected = [];
    this.domainItemsSelected = [];
    this.showDelete = true;
    if(localStorage.isCustomerAdminDeleteDisable){
      localStorage.removeItem('isCustomerAdminDeleteDisable')
    }
    this.onReset();
    this.showPage = false;
    this.domainRolesChanged = false;
    this.showRetryCount = false;
    this.showSearchContainer = false
    this.showApproveEmail = false
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
  }

  private MatchPassword(abstractControl: AbstractControl) {
    const Password = abstractControl.get('Password').value // to get value in input tag
    const ConfirmPassword = abstractControl.get('ConfirmPassword').value // to get value in input tag
    if (Password == "") {
      abstractControl.get('Password').setErrors({required: true});
    } else if (ConfirmPassword == "") {
      abstractControl.get('ConfirmPassword').setErrors({required: true});
    }

    if (Password != ConfirmPassword && ConfirmPassword != "") {
      abstractControl.get('ConfirmPassword').setErrors({ MatchPassword: true });
    } else if(ConfirmPassword != "") {
      abstractControl.get('ConfirmPassword').setErrors(null);
    }
  }



  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this.deleteUser = true;
          if(!this.isSSO){
            this.showConfirmPassword = true;
            setTimeout(() => {
              this.ngxSmartModalService.getModal('confirmPassword').open();
            }, 0)
            setTimeout(() => {
              this.focusconfirmPassword.setFocus();
            }, 200);
          }else{
            this.saveUserDetails(this.userForm);
          }

          this._commonService.log(res, this._commonService.LOG);
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  goBack() {
    this.location.back();
  }


  onSelect(event) {
    let selected = [];
    event.selected.forEach(element => {
      selected.push(element.ObjectGroupId);
    });
    this.itemsSelected = selected;
  }

  updated(event) {
    console.log("The value", event)
  }



  masterRoleId: any = null;



  addDomainRoles(){
    if(!this.searchText){

      this.globalRole = null
      let f = this.user.DomainRoles.find(f => f.RoleId == 'a268d471-b525-42f2-a6e6-73ec4073f3fb' ||  f.RoleId == 'fe0380d2-aea5-4c20-95a6-5882712eaf84')
      if(f){
        this.user.DomainRoles.push({
          DomainId: null,
          RoleId: f.RoleId,
          DomainName: null,
        })
        this.paginatorRoles.push({
          DomainId: null,
          RoleId: f.RoleId,
          DomainName: null,
        })
      }else{

        this.user.DomainRoles.push({
          DomainId: null,
          RoleId: null,
          DomainName: null,
        })

        this.paginatorRoles.push({
          DomainId: null,
          RoleId: null,
          DomainName: null,
        })
      }
      this.count ++ ;
      this.user.DomainRoles = [...this.user.DomainRoles];
      this.paginatorRoles = [...this.paginatorRoles];
      if( this.user.DomainRoles && this.user.DomainRoles.length > 0){
        this.isAddDisable = false
        let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
        if(firstElem && firstElem.DomainId){
          let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
          if(domainName == 'master'){
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
          }else{
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
          }
        }
        if(firstElem && !firstElem.DomainId){
          this.isAddDisable = true
        }
      }


        let lastPage =   Math.ceil(this.user.DomainRoles.length / this.pageSize)
        this.skip = (lastPage - 1) * this.pageSize
        this.forcePageNumber = lastPage
        this.forceCurrentPage = lastPage
        this.paginatorRoles = this.user.DomainRoles.slice((this.forcePageNumber - 1) * this.pageSize , ((this.forcePageNumber - 1) * this.pageSize)  + this.pageSize)

        setTimeout(() => {
          this.forcePageNumber = null
        }, 200);


      setTimeout(() => {
        if (this.content.scrollToBottom) {
          this.content.scrollToBottom(200);
        }
      }, 0);
    }else{
      this.globalRole = null
      this.searchText = ''
      this.showSearchContainer = false
      this.count =  this.user.DomainRoles.length
      let f = this.user.DomainRoles.find(f => f.RoleId == 'a268d471-b525-42f2-a6e6-73ec4073f3fb' ||  f.RoleId == 'fe0380d2-aea5-4c20-95a6-5882712eaf84')
      if(f){
        this.user.DomainRoles.push({
          DomainId: null,
          RoleId: f.RoleId,
          DomainName: null,
        })
        this.paginatorRoles.push({
          DomainId: null,
          RoleId: f.RoleId,
          DomainName: null,
        })
      }else{

        this.user.DomainRoles.push({
          DomainId: null,
          RoleId: null,
          DomainName: null,
        })

        this.paginatorRoles.push({
          DomainId: null,
          RoleId: null,
          DomainName: null,
        })
      }
      this.count ++ ;
      this.user.DomainRoles = [...this.user.DomainRoles];
      this.paginatorRoles = [...this.paginatorRoles];
      if( this.user.DomainRoles && this.user.DomainRoles.length > 0){
        this.isAddDisable = false
        let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
        if(firstElem && firstElem.DomainId){
          let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
          if(domainName == 'master'){
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
          }else{
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
          }
        }if(firstElem && !firstElem.DomainId){
          this.isAddDisable = true
        }
      }


        let lastPage =   Math.ceil(this.user.DomainRoles.length / this.pageSize)
        this.skip = (lastPage - 1) * this.pageSize
        this.forcePageNumber = lastPage
        this.forceCurrentPage = lastPage
        this.paginatorRoles = this.user.DomainRoles.slice((this.forcePageNumber - 1) * this.pageSize , ((this.forcePageNumber - 1) * this.pageSize)  + this.pageSize)

        setTimeout(() => {
          this.forcePageNumber = null
        }, 200);


      setTimeout(() => {
        if (this.content.scrollToBottom) {
          this.content.scrollToBottom(200);
        }
      }, 0);
    }
  }

  deleteDomainRoles(element) {
   if(!this.searchText){
     if(element.RoleId && element.DomainName){
       let roleCode = this.user.AllRoles.find(f => f.UserRoleId == element.RoleId).UserRoleCode
       if(element.DomainName.toLowerCase() == 'master' && roleCode == 'UserRole_Administrator'){
         this.showMasterOnly = false
         this.user.DomainRoles = []
         this.showLinkedToAllDomain = false
       }
     }

     let index = this.user.DomainRoles.findIndex((item, index) => {return item.DomainId == element.DomainId});
     this.user.DomainRoles.splice(index, 1);
     let i = this.paginatorRoles.findIndex((item, index) => {return item.DomainId == element.DomainId});
     this.paginatorRoles.splice(i, 1);
     this.count -- ;

     let lastPage =   Math.ceil(this.user.DomainRoles.length / this.pageSize)
     if(this.forceCurrentPage){
       this.skip = (this.forceCurrentPage - 1) * this.pageSize
     }else{
       this.skip = 0
     }

     this.paginatorRoles = this.user.DomainRoles.slice(this.skip , this.skip + this.pageSize)

     if( this.paginatorRoles.length == 0){
     this.user.AllRoles = [...this.tempUserRole]
     this.user.Domains = [...this.tempDomains]
       if(this.forceCurrentPage != 1){
         this.forcePageNumber = this.forceCurrentPage - 1
         this.forceCurrentPage = this.forceCurrentPage - 1
         this.paginatorRoles = this.user.DomainRoles.slice((this.forcePageNumber - 1) * this.pageSize , ((this.forcePageNumber - 1) * this.pageSize)  + this.pageSize)

         setTimeout(() => {
           this.forcePageNumber = null
         }, 200);
       }
     }
   }else{
    if(element.RoleId && element.DomainName){
      let roleCode = this.user.AllRoles.find(f => f.UserRoleId == element.RoleId).UserRoleCode
      if(element.DomainName.toLowerCase() == 'master' && roleCode == 'UserRole_Administrator'){
        this.showMasterOnly = false
        this.user.DomainRoles = []
        this.showLinkedToAllDomain = false
      }
    }

    let index = this.user.DomainRoles.findIndex((item, index) => {return item.DomainId == element.DomainId});
    this.user.DomainRoles.splice(index, 1);
    let i = this.paginatorRoles.findIndex((item, index) => {return item.DomainId == element.DomainId});
    this.paginatorRoles.splice(i, 1);
    let j = this.tempPaginatorRoles.findIndex((item, index) => {return item.DomainId == element.DomainId});
    this.tempPaginatorRoles.splice(i, 1);
    this.count -- ;

    let lastPage =   Math.ceil(this.tempPaginatorRoles.length / this.pageSize)
    if(this.forceCurrentPage){
      this.skip = (this.forceCurrentPage - 1) * this.pageSize
    }else{
      this.skip = 0
    }

    this.paginatorRoles = this.tempPaginatorRoles.slice(this.skip , this.skip + this.pageSize)

    if( this.paginatorRoles.length == 0){
    this.user.AllRoles = [...this.tempUserRole]
    this.user.Domains = [...this.tempDomains]
      if(this.forceCurrentPage != 1){
        this.forcePageNumber = this.forceCurrentPage - 1
        this.forceCurrentPage = this.forceCurrentPage - 1
        this.paginatorRoles = this.tempPaginatorRoles.slice((this.forcePageNumber - 1) * this.pageSize , ((this.forcePageNumber - 1) * this.pageSize)  + this.pageSize)

        setTimeout(() => {
          this.forcePageNumber = null
        }, 200);
      }
    }
   }

    this.checkToShowAllLinkedDomain()
  }

   filterDomains(id) {
     let result = []

     if(this.user.Domains){
     this.user.Domains.forEach(element => {
      if(this.user.DomainRoles){
        let temp =  this.user.DomainRoles.find( f => f.DomainId == element.DomainId)
        if(!temp){
          result.push(element)
        }
        if(element.DomainId == id){
          result.push(element)
        }
      }

     });

      return result
  }
}

  filterRoles(id) {
    // if(id){

    //   let domainName = this.user.Domains.find( f => f.DomainId == id).Name.toLowerCase();
    //  if(domainName == 'master'){
    //     let temp =  this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')
    //     return temp;
    //  }else{
    //   let temp =  this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_Administrator')
    //   return temp;
    //  }
    // }else{
    //   return this.user.AllRoles;
    // }
    return this.user.AllRoles;
 }

 filterDomainRoles() {
   return this.paginatorRoles
}

  onRoleChange(ele, roleId, domainId){

    let domainName: any
    let roleCode = this.user.AllRoles.find(f => f.UserRoleId == roleId).UserRoleCode
    if(roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal' || roleCode == 'UserRole_Administrator'){
      this.isAddDisable = false
      if(this.filterMaster){
        this.user.Domains.push(this.filterMaster)
        this.user.Domains = [... this.user.Domains]
      }
      if(!this.isAlreadycase){
        ele.DomainId =  this.user.Domains.find( f => f.Name == 'MASTER').DomainId;
        domainId =  this.user.Domains.find( f => f.Name == 'MASTER').DomainId;
        ele.DomainName =  this.user.Domains.find( f => f.DomainId ==   ele.DomainId ).Name;
        ele.disableDelete = true
        ele.isDomainSelectDisabled = true
        let index = this.user.DomainRoles.findIndex((item, index) => { return item.DomainId == ele.DomainId });
        if(index > 0){
          this.array_move(this.user.DomainRoles,index, 0)
      }else if(index == 0){
        this.isAlreadycase = true
      }
      }

      if( this.user.DomainRoles && this.user.DomainRoles.length > 0){
        this.isAddDisable = false
        let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
        if(firstElem && firstElem.DomainId){
          let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
          if(domainName == 'master'){
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
          }else{
            this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
          }
        }
      }

    }else{
      try {
        if (this.filterMaster) {
          this.user.Domains.push(this.filterMaster);
        }
      } catch (error) {
        console.error( error);
      }


      this.filterMaster = this.user.Domains.find( f => f.Name == 'MASTER');
      this.user.Domains = [...this.user.Domains.filter(f => f.Name != 'MASTER' )];
    }

    if(domainId){
      domainName = this.user.Domains.find( f => f.DomainId == domainId).Name.toLowerCase();
    }
    if(domainName == 'master' && roleCode == 'UserRole_Administrator' ){
     this.showMasterOnly = true
     this.isAlreadycase = false
     this.count = 1
     this.showLinkedToAllDomain = false
    }else{

      if(this.showMasterOnly){
        this.searchText =''
        this.count =  this.user.DomainRoles.length;
        this.paginatorRoles = this.user.DomainRoles.slice(0 , this.pageSize)
      }

      this.showMasterOnly = false
      if(roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal'){

        this.globalRole = roleCode
        this.user.DomainRoles.forEach(element => {
          element.RoleId = roleId
        });
        if(!this.isAlreadycase){
          ele.DomainId =  this.user.Domains.find( f => f.Name.toLowerCase() == 'master').DomainId.toLowerCase();
          ele.isDomainSelectDisabled = true
          let index = this.user.DomainRoles.findIndex((item, index) => { return item.DomainId == ele.DomainId });
          if(index > 0){
            ele.disableDelete = true
              this.array_move(this.user.DomainRoles,index, 0)

          }else if(index == 0){
            ele.disableDelete = true
            this.isAlreadycase = true
          }
        }

      }

      if(roleCode == 'UserRole_Administrator'){
        ele.DomainId =  this.user.Domains.find( f => f.Name.toLowerCase() == 'master').DomainId;
        ele.DomainName = this.user.Domains.find( f => f.DomainId ==   ele.DomainId ).Name;
        ele.isDomainSelectDisabled = true
        this.showMasterOnly = true
      }

      this.user.DomainRoles.forEach(element => {

        if(element.RoleId){
          let roleCode = this.user.AllRoles.find(f => f.UserRoleId == element.RoleId).UserRoleCode
          if( ( roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal') &&  element.RoleId != roleId){
            element.RoleId = 0

             this.isAlreadycase = false
          }
        }
      });
      this.user.DomainRoles = [...this.user.DomainRoles.filter(f=> f.RoleId != 0 )]
      this.paginatorRoles = [...this.paginatorRoles.filter(f=> f.RoleId != 0 )]
      if( this.user.DomainRoles.length == 1){
        this.count = 1
        this.forcePageNumber = 1
      }

      this.checkToShowAllLinkedDomain()
    }


  }

  onDomainChanged(index,ele, roleId) {
    if( this.user.DomainRoles && this.user.DomainRoles.length > 0){

      let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
      if(firstElem && firstElem.DomainId){
        this.isAddDisable = false
        let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
        if(domainName == 'master'){
          this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
        }else{
          this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
        }
      }
    }



    let roleCode: any = null

    this.selectedDomainName = this.user.Domains.find( f => f.DomainId == ele.DomainId).Name.toLowerCase();
    if(roleId){

       roleCode = this.user.AllRoles.find(f => f.UserRoleId == roleId).UserRoleCode
    }
    ele.DomainName =  this.selectedDomainName

    if(this.selectedDomainName != 'master'){
      if (roleCode && roleCode == 'UserRole_Administrator'){
        if(this.showMasterOnly){
          this.searchText =''
          this.count =  this.user.DomainRoles.length;
          this.paginatorRoles = this.user.DomainRoles.slice(0 , this.pageSize)
        }
      }
      this.showMasterOnly = false
      if(this.globalRole){
        ele.RoleId = this.user.AllRoles.find(f => f.UserRoleCode == this.globalRole).UserRoleId
      }
    }else if(this.selectedDomainName == 'master' && roleCode && roleCode == 'UserRole_Administrator'){
      ele.RoleId = null

    }

    this.checkToShowAllLinkedDomain()
   }

   array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    this.isAlreadycase = true
    this.skip = 0
    this.paginatorRoles = this.user.DomainRoles.slice(0 , this.pageSize)
    if( this.user.DomainRoles && this.user.DomainRoles.length > 0){
      this.isAddDisable = false
      let firstElem = this.user.DomainRoles ? this.user.DomainRoles[0] : null
      if(firstElem && firstElem.DomainId){
        let domainName =  this.user.Domains.find( f => f.DomainId == firstElem.DomainId).Name.toLowerCase();
        if(domainName == 'master'){
          this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode != 'UserRole_CustomerAdmin' && f.UserRoleCode != 'UserRole_CustomerUser')]
        }else{
          this.user.AllRoles = [... this.user.AllRoles.filter( f => f.UserRoleCode == 'UserRole_CustomerAdmin' || f.UserRoleCode == 'UserRole_CustomerUser')]
        }
      }
    }

};


  setPasswordValidation(event) {
    const passwordControl = this.userForm.get('Password');
    const confirmPasswordControl = this.userForm.get('ConfirmPassword');

    let password = this.userForm.controls["Password"].value;
    let confirmPassword = this.userForm.controls["ConfirmPassword"].value;
    if (this.showPage) {
      if ((password != "********") && (password != "")) {
        passwordControl.setValidators([Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/)]);
        passwordControl.updateValueAndValidity();
      } else {
        passwordControl.clearValidators();
        passwordControl.setErrors(null);
      }

      if ((confirmPassword != "********")) {
        if ((password != "********") && (password != "") && (confirmPassword != password)) {
          confirmPasswordControl.setValidators([Validators.required]);
          confirmPasswordControl.updateValueAndValidity();
        } else {
          confirmPasswordControl.clearValidators();
          confirmPasswordControl.setErrors(null);
        }
      }
    }
  }


  openResetCountPassword() {
    this.showConfirmResetCountPassword = true;
    if(!this.isSSO){
      setTimeout(() => {
        this.ngxSmartModalService.getModal('confirmResetCountPassword').open();
      }, 0);
      setTimeout(() => {
        this.focusresetCount.setFocus();
      }, 200);
    }else{
      this.resetRetryCount(this.confirmResetCountPasswordForm);
    }

  }

  async resetRetryCount(form) {
    try {
      if(!this.isSSO){
        this.ngxSmartModalService.getModal('confirmResetCountPassword').close()
      }
      this.showConfirmResetCountPassword = false;
      this._commonService.presentLoading();
      let data = {
        UserPassword: this.isSSO?'':form.value.UserRetryPassword
      }
      await this._apiService.resetRetryCount(this.userId, data);
      this.user.RetryCount = 0;
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  setPage(event) {
    this.page.pageNumber = event.offset + 1;
  }

  public onLimitChange(limit: any): void {
    this.page.pageNumber = 0;
    this.page.size = parseInt(limit, 10);
  }





  onChangeBreadcrumb() {
    this.user.FirstName = this.userForm.value.FirstName;
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit(true, false, false);
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;
    }

  }


  BirthDateTimeChange(event) {
    this.userForm.patchValue({
      Birthdate: this.datePipe.transform(new Date(event.value), "dd-MM-yyyy"),
    })
  }

  resetDate() {
    this.user.Birthdate = "";
    this.userForm.patchValue({
      Birthdate: null
    })
  }

  checkToShowAllLinkedDomain(){
    if(this.user.DomainRoles && this.user.DomainRoles.length > 0){
      this.user.DomainRoles.forEach(element => {
        if(element.RoleId != null){

          let roleCode = this.user.AllRoles.find(f => f.UserRoleId == element.RoleId).UserRoleCode
          if(roleCode == 'UserRole_Support' || roleCode == 'UserRole_Legal'){
            let domainName = this.user.DomainRoles.find(f => f.DomainId == '100fdbfc-9894-415c-a79f-9de156c716de')
            if(domainName){
                this.showLinkedToAllDomain = true
            }else{
              this.showLinkedToAllDomain = false
            }
          }else{
            this.showLinkedToAllDomain = false
          }
        }
      });
    }
  }

  async onChangePage(pageData) {
    if(!this.searchText){
      if(this.pageSize != pageData.pageSize){
        pageData.currentPage = 1
      }
      this.forcePageNumber = null;
      this.pageSize = Number(pageData.pageSize);
      this.skip = this.pageSize * (pageData.currentPage - 1);
      this.paginatorRoles = this.user.DomainRoles.slice(this.skip, (this.skip + this.pageSize))
      this.forceCurrentPage =  pageData.currentPage
    }else{
      if(this.pageSize != pageData.pageSize){
        pageData.currentPage = 1
      }
      this.forcePageNumber = null;
      this.pageSize = Number(pageData.pageSize);
      this.skip = this.pageSize * (pageData.currentPage - 1);
      this.paginatorRoles = [...this.tempPaginatorRoles.slice(this.skip,  (this.skip + this.pageSize))]
      this.forceCurrentPage =  pageData.currentPage
    }
  }



  autofocusInput() {
    this.ionInput.setFocus();
  }

  clearField() {
    if (this.searchText != '') {
      this.searchDomainRoles('');
    }else{
      this.searchDomainRoles('');
    }
  }

  searchDomainRoles(searchtext){
    this._commonService.presentLoading()
    if(this.user.DomainRoles.length == 0){
      return []
    }
    if(!searchtext){
      this.searchText = ''
      if(!this.showMasterOnly){

        this.count =  this.user.DomainRoles.length
        this.tempPaginatorRoles = []
        this.skip = 0
        this.paginatorRoles = [...this.user.DomainRoles.slice(0,  this.pageSize)]
      }

    }else{
      searchtext = searchtext.toLowerCase();
       this.paginatorRoles =  this.user.DomainRoles.filter( it => {
         if(it.DomainName){
           return it.DomainName.toLowerCase().includes(searchtext);
         }
      });
      this.tempPaginatorRoles = [...this.paginatorRoles]
      this.count =  this.paginatorRoles.length
      this.paginatorRoles = [...this.paginatorRoles.slice(0,  this.pageSize)]
    };
    this._commonService.dismiss()

   }

   accessAllDomain(event){
    this.AccessAllDomain = event  ? 1 : 0
   }


}
